/**
 * Copyright Open Logistics Foundation
 *
 * Licensed under the Open Logistics Foundation License 1.3.
 * For details on the licensing terms, see the LICENSE file.
 * SPDX-License-Identifier: OLFL-1.3
 */

import { Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';

@Injectable({
    providedIn: 'root',
})
export class EcmrUrlResolverService {
    constructor(private appConfig: AppConfig) {}

    getEcmrUrl(): string {
        return this.appConfig.ecmrUrl;
    }
}
